// extracted by mini-css-extract-plugin
export default {"scrollContainer":"JUGYr_HqKUADy07TY1FQ","bounce":"HCEoroGLLcLN00VuKsvw"};